/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanStateOverflowFundDtoFund
 */
export interface MonthPlanStateOverflowFundDtoFund {
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateOverflowFundDtoFund
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MonthPlanStateOverflowFundDtoFund
   */
  name: string;
}

export function MonthPlanStateOverflowFundDtoFundFromJSON(json: any): MonthPlanStateOverflowFundDtoFund {
  return MonthPlanStateOverflowFundDtoFundFromJSONTyped(json, false);
}

export function MonthPlanStateOverflowFundDtoFundFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanStateOverflowFundDtoFund {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function MonthPlanStateOverflowFundDtoFundToJSON(value?: MonthPlanStateOverflowFundDtoFund | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
